export default [
  {
    path: '/challenges/tracks',
    name: 'Challenges Tracks',
    component: () =>
      import(/* webpackChunkName: 'challenges/tracks' */ './views/Index.vue')
  },
  {
    path: '/challenges/brands',
    name: 'Challenges Brands',
    component: () =>
      import(/* webpackChunkName: 'challenges/brands' */ './views/Brands.vue')
  },
]
